import { useEffect, useState } from 'react';
import { getUserInfo } from 'services/user';
import { removeToken } from 'utils/actionToken';
import { useSaveReferralCode } from '@blofin/blofin-utils';
import { useRouter } from 'next/router';

const useUser = () => {
  const [info, setInfo] = useState<any | null>(null);

  const router = useRouter();
  const { saveReferralCode } = useSaveReferralCode();

  const getUser = async () => {
    try {
      const res = await getUserInfo<{ code: number; data: InfoState }>();
      if (res.code === 200) {
        setInfo(res.data);
      } else {
        removeToken();
        setInfo({
          nick_name: '',
          profile: '',
          state: 0,
          uid: '',
          user_level: 0,
          vip_level: 0,
        });
      }
    } catch (error) {}
  };
  useEffect(() => {
    getUser();

    if (router.query.referral_code) {
      saveReferralCode(router.query.referral_code as string);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    userInfo: info,
  };
};

export default useUser;
